import { useEffect, useState, useCallback } from "react";
import { useAuth } from "../../../context/AuthContext";

export const useLoginFormState = () => {
  const { login, loginWithGoogle, loadingAuth, authError, setAuthError } = useAuth();

  const [emailInput, setEmailInput] = useState("");
  const [passwordInput, setPasswordInput] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    setAuthError(null);
  }, [setAuthError]);

  const handleSubmit = useCallback(
    async (event) => {
      event.preventDefault();
      await login(emailInput, passwordInput);
    },
    [emailInput, passwordInput, login],
  );

  const togglePasswordVisibility = useCallback(() => {
    setShowPassword((prev) => !prev);
  }, []);

  const clearAuthError = useCallback(() => setAuthError(null), [setAuthError]);

  const handleGoogleError = useCallback(
    (message) => {
      setAuthError(message || "Google login failed. Please try again.");
    },
    [setAuthError]
  );

  return {
    authError,
    clearAuthError,
    emailInput,
    handleSubmit,
    loadingAuth,
    loginWithGoogle,
    passwordInput,
    handleGoogleError,
    setEmailInput,
    setPasswordInput,
    setShowPassword,
    showPassword,
    togglePasswordVisibility,
  };
};
